module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-14.b041dbfc.png";